import { UtensilsCrossed } from "lucide-react";

/**
 * ChefSync P&L brand mark.
 * Crossed knife + fork glyph on a dark circle — green accent.
 * Used in the navbar header.
 */
export default function Logo({ size = 36, className = "" }) {
  return (
    <span
      className={`inline-grid place-items-center rounded-full bg-[var(--logo-bg)] ${className}`}
      style={{ width: size, height: size }}
      aria-label="ChefSync P&L logo"
      data-testid="brand-logo"
    >
      <UtensilsCrossed
        size={Math.round(size * 0.55)}
        strokeWidth={2.5}
        className="text-[var(--brand-accent)]"
        aria-hidden="true"
      />
    </span>
  );
}
